var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGrossNpaIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9958 4.749C14.4438 4.749 13.9953 4.3005 13.9953 3.7485V1.9995H9.99478V3.75C9.99478 4.302 9.54777 4.7505 8.99427 4.7505C8.44227 4.7505 7.99377 4.302 7.99377 3.75V1.9995C7.99377 0.897 8.89077 0 9.99327 0H13.9938C15.0963 0 15.9933 0.897 15.9933 1.9995V3.75C15.9963 4.302 15.5493 4.749 14.9958 4.749Z",
    fill: "#00D2A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6198 10.2495H12.3803C13.5488 10.2495 14.4998 11.2005 14.4998 12.369C14.4998 13.4205 13.7423 14.2845 12.7493 14.4615V15.249C12.7493 15.663 12.4133 15.999 11.9993 15.999C11.5853 15.999 11.2493 15.663 11.2493 15.249V14.499H10.2488C9.83483 14.499 9.49883 14.163 9.49883 13.749C9.49883 13.335 9.83483 12.999 10.2488 12.999H12.3788C12.7208 12.999 12.9983 12.72 12.9983 12.3795C12.9983 12.0285 12.7193 11.7495 12.3788 11.7495H11.6183C10.4498 11.7495 9.49883 10.7985 9.49883 9.63C9.49883 8.5785 10.2563 7.7145 11.2493 7.5375V6.75C11.2493 6.336 11.5853 6 11.9993 6C12.4133 6 12.7493 6.336 12.7493 6.75V7.5H13.7498C14.1638 7.5 14.4998 7.836 14.4998 8.25C14.4998 8.664 14.1638 9 13.7498 9H11.6198C11.2778 9 11.0003 9.279 11.0003 9.6195C10.9988 9.9705 11.2778 10.2495 11.6198 10.2495ZM2.74883 3C1.23233 3 -0.000671387 4.233 -0.000671387 5.7495V16.2495C-0.000671387 17.766 1.23233 18.999 2.74883 18.999H21.2483C22.7663 18.999 23.9993 17.766 23.9993 16.2495V5.7495C23.9993 4.233 22.7663 3 21.2498 3H2.74883Z",
    fill: "#6C7DE5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGrossNpaIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gross_npa_icon.3b31d01b11dc7d14801e20f00ca042b0.svg";